import { ColumnTableConfig } from "./column-table-config";
import { Paging } from "./page";

export class ColumnTable {
  code: string;
  description: string;
  type: string;
  cellFn: ((param: any) => any);
  switchFn: ((param: any) => any);
  disableSwitchFn: ((param: any) => any);
  actions: {
    fn: ((param: any) => any),
    icon: string,
    tooltip: string,
    isDisabled: boolean,
    disabledFn?: ((param: any) => boolean),
    isPrivileged?: boolean,
    privilege?: string,
    isPopOver?: boolean,
    popOverTemplate?: any,
    popOverPlacement?: 'top' | 'bottom' | 'left' | 'right',
    triggers?: 'click' | 'hover' | 'focus' | 'manual' | 'mouseenter:mouseleave' | 'click:blur' | 'focus:blur' | string,
  }[];
  cellTooltip: string;
  valueMap: Map<string, string>;
  editable: boolean;
  required: boolean;
  valueMapKeys: Array<string>;
  iconClass: string;
  isIcon: boolean;
  isSmall: boolean;
  isSelfComboBoxDataSource: boolean;
  wordWrap: boolean;
  secondText: string;
  currencyField: string;
  selectedAllSwitch: boolean;
  selectAllSwitchFn: (param: Paging<Array<any>>, result: boolean) => any;
  dateFormat: string;
  dateType: string;
  justEditLastOne: boolean;
  useToFieldToCheckSelectedCache: boolean;
  max: boolean;
  fieldToSetMax: string
  constructor(code: string, description: string, config?: Partial<ColumnTableConfig>) {
    let actions = config?.actions ?? { fn: (() => { }), icon: "", tooltip: "", isDisabled: false, disabledFn: (() => { return false; }), isPrivileged: false, privilege: "" };
    this.code = code;
    this.description = description;
    this.type = config?.type ?? "text";
    this.actions = !("length" in actions) ? [actions] : actions;
    this.actions.forEach(f => {
      f.disabledFn = f.disabledFn ?? (() => { return f.isDisabled; })
    })
    this.cellFn = config?.cellFn || (() => { });
    this.switchFn = config?.switchFn || (() => { });
    this.cellTooltip = config?.cellTooltip || "";
    this.valueMap = config?.valueMap || new Map<string, string>();
    this.editable = config?.editable || false;
    this.required = config?.required || false;
    this.valueMapKeys = Array.from(this.valueMap.keys()) || [];
    this.iconClass = config?.iconClass || "";
    this.isIcon = config?.isIcon || false;
    this.isSmall = config?.isSmall || false;
    this.isSelfComboBoxDataSource = config?.isSelfComboBoxDataSource || false;
    this.secondText = config?.secondText || "";
    this.disableSwitchFn = config?.disableSwitchFn || (() => { });
    this.currencyField = config?.currencyField || "";
    this.selectedAllSwitch = config?.selectedAllSwitch || false;
    this.selectAllSwitchFn = config?.selectAllSwitchFn || (() => { });
    this.dateFormat = config?.dateFormat || "medium";
    this.dateType = config?.dateType || "default";
    this.justEditLastOne = config?.justEditLastOne || false;
    this.useToFieldToCheckSelectedCache = config?.useToFieldToCheckSelectedCache || false;
    this.max = config?.max || false;
    this.fieldToSetMax = config?.fieldToSetMax || '';
    this.wordWrap = config?.wordWrap ?? false;
  }
}
